import { render, staticRenderFns } from "./DocumentBody.vue?vue&type=template&id=bc665ca2&"
import script from "./DocumentBody.vue?vue&type=script&lang=js&"
export * from "./DocumentBody.vue?vue&type=script&lang=js&"
import style0 from "./DocumentBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ctweb/fontend/kecc/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc665ca2')) {
      api.createRecord('bc665ca2', component.options)
    } else {
      api.reload('bc665ca2', component.options)
    }
    module.hot.accept("./DocumentBody.vue?vue&type=template&id=bc665ca2&", function () {
      api.rerender('bc665ca2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DefaultHome/KECC/Press/Document/DocumentBody.vue"
export default component.exports